// generated: 5/27/2026, 8:28:59 AM

export default {
    production: true,
    apiBasePath: 'https://api.dev.car-tracking-online.com',
    region: 'eu-central-1',
    segmentWriteKey: 'sL9YpOF4P1c3dz0wFXFXF4OsKaMqn41V',
    sendTrackingEvents: true
};
